/**
 * The old browser-only "Chat Notifications" toggle (`notifyOnChatCompletion`
 * in the persisted `ui-storage`), kept just long enough to move it to the
 * server (see `migrateNotifyPreference.ts`).
 *
 * uiStore no longer has the field, so the next write of `ui-storage` drops
 * it. uiStore's persist `merge` therefore hands the hydrated value here, and
 * a `false` is kept under its own key until the migration has saved it on
 * the server. No imports: uiStore loads this at startup.
 */

/** Set to '1' while an old "off" still has to be saved on the server. */
export const LEGACY_NOTIFY_OFF_KEY = 'andi.legacyNotifyOff';

/** Called with uiStore's persisted state on hydration. Never throws. */
export function stashLegacyNotifyPreference(persisted: unknown): void {
  try {
    if (typeof persisted !== 'object' || persisted === null) return;
    const value = (persisted as { notifyOnChatCompletion?: unknown }).notifyOnChatCompletion;
    if (value === false) localStorage.setItem(LEGACY_NOTIFY_OFF_KEY, '1');
  } catch {
    // Storage blocked: nothing to keep.
  }
}

/** Whether an old "off" is waiting to be saved on the server. */
export function hasLegacyNotifyOff(): boolean {
  try {
    return localStorage.getItem(LEGACY_NOTIFY_OFF_KEY) === '1';
  } catch {
    return false;
  }
}

/** Forget the old value once the server holds the choice. */
export function clearLegacyNotifyOff(): void {
  try {
    localStorage.removeItem(LEGACY_NOTIFY_OFF_KEY);
  } catch {
    // ignore
  }
}
